/*********************** Custom JS for Boost AI Search & Discovery  ************************/
// More info about V3 customization here: https://help.boostcommerce.net/article/938-for-dev-app-customization-app-lib-v3
// ###===> window.customer_status is assigned the value in file theme.liquid line#224-229
/*-------------------- Custom Functions ----------------------*/
window.boostSdEnableRefineByInCollectionPage = true; 
boostSDAppConfig.filterSettings.filterTreeMobileStyle = 'style1';

let typingTimer;
const doneTypingInterval = 1000; // Adjust this value as needed (in milliseconds)
let currentCollectionTitle = "All";
let currentProductData = [];
function clearActiveYMMBox () {
  document.getElementById(FindYourVehicleGlob.DROPDOWN_YEAR_PLACEHOLDER).classList.remove('active-box');
  document.getElementById(FindYourVehicleGlob.DROPDOWN_MAKE_PLACEHOLDER).classList.remove('active-box');
  document.getElementById(FindYourVehicleGlob.DROPDOWN_MODEL_PLACEHOLDER).classList.remove('active-box');
  FindYourVehicleAPI.updateYMMLookUI({isYMMApplied:false});
  FindYourVehicleAPI.toggleYmmFits(false);
}
function removeSpaces(str) {
  return str.replace(/\s+/g, '');
}
function replaceLinkShortcode(text, url) {
    // Define the regular expression to match [LINK]here[/LINK] pattern
    const linkRegex = /\[LINK\](.*?)\[\/LINK\]/g;

    // Replace the pattern with the appropriate <a> tag
    const replacedText = text.replace(linkRegex, `<a style="color:#00b2ec;text-decoration:underline;" href="${url}">$1</a>`);

    return replacedText;
}
function replaceContactLinkShortcode(text, url) {
    // Define the regular expression to match [CONTACT_LINK]here[/CONTACT_LINK] pattern
    const linkRegex = /\[CONTACT_LINK\](.*?)\[\/CONTACT_LINK\]/g;

    // Replace the pattern with the appropriate <a> tag
    const replacedText = text.replace(linkRegex, `<a style="color:#00b2ec;text-decoration:underline;" href="${url}">$1</a>`);

    return replacedText;
}
function replaceClearAllLinkShortcode(text, url) {
    // Define the regular expression to match [CONTACT_LINK]here[/CONTACT_LINK] pattern
    const linkRegex = /\[CLEAR_ALL_LINK\](.*?)\[\/CLEAR_ALL_LINK\]/g;

    // Replace the pattern with the appropriate <a> tag
    const replacedText = text.replace(linkRegex, `<a onclick="${url}" style="color:#00b2ec;text-decoration:underline;" href="javascript:void(0);">$1</a>`);

    return replacedText;
}
function replaceNewLineShortcode(text, url) {
    // Define the regular expression to match [CONTACT_LINK]here[/CONTACT_LINK] pattern
    const linkRegex = /\[NEW_LINE\](.*?)\[\/NEW_LINE\]/g;

    // Replace the pattern with the appropriate <a> tag
    const replacedText = text.replace(linkRegex, url);

    return replacedText;
}
function clearAllLink () {
  clearActiveYMMBox();
  triggerRefineByClearAll();
  updateMenuLinks('');
  sessionStorage.removeItem('FYV');
  sessionStorage.removeItem('YMM_YEAR');
  sessionStorage.removeItem('YMM_MAKE');
  sessionStorage.removeItem('YMM_MODEL');
  removeParamsFromURL(["year", "make", "model"]);
  FindYourVehicleAPI.resetDropDowns(0, false);
  FindYourVehicleAPI.resetDropDowns(1);
  FindYourVehicleAPI.resetDropDowns(2);
  location.href = "/collections/all";
}

function clearAllActiveSearches() {
    const removeYMMTemplateList = [];
    if (removeYMMTemplateList.includes(window.theme.template)) {
        triggerRefineByClearAll();
        updateMenuLinks('');
        sessionStorage.removeItem('FYV');
        sessionStorage.removeItem('YMM_YEAR');
        sessionStorage.removeItem('YMM_MAKE');
        sessionStorage.removeItem('YMM_MODEL');
        removeParamsFromURL(["year", "make", "model"]);
        FindYourVehicleAPI.resetDropDowns(0, false);
        FindYourVehicleAPI.resetDropDowns(1);
        FindYourVehicleAPI.resetDropDowns(2);
    }
}

function triggerRefineByClearAll() {
    let clearAllButton = document.querySelector('.boost-sd__refine-by-vertical-refine-by .boost-sd__button--clear');
    if (clearAllButton) {
        clearAllButton.click();
    }
}

function updateMenuLinks(searchParams) {
    // Select the menu bar div
    const menuBar = document.querySelector('.menu-bar');
    // Check if the menu bar exists
    if (menuBar) {
        // Get all <a> elements within the menu bar
        const menuLinks = menuBar.querySelectorAll('a');
        // Loop through each <a> element
        menuLinks.forEach(link => {
            // Check if the href contains "/collections/"
            if (link.href.includes("/collections/")) {
                // Add search params to the href
                // Example: Add "?param=value"
                if (link.href.includes("?")) {
                    link.href = link.href.split('?')[0];
                }
                if (searchParams !== '') {
                    link.href += '?' + searchParams;
                }
            }
        });
    }
}

function removeParamsFromURL(paramsToRemove) {
    // Function to remove specified parameters from the URL
    function removeParams() {
        var urlParams = new URLSearchParams(window.location.search);
        paramsToRemove.forEach(param => urlParams.delete(param));
        var newURL = window.location.pathname + '?' + urlParams.toString();
        window.history.pushState({
            path: newURL
        }, '', newURL);
        updateMenuLinks('');
        sessionStorage.removeItem('FYV');
        sessionStorage.removeItem('YMM_YEAR');
        sessionStorage.removeItem('YMM_MAKE');
        sessionStorage.removeItem('YMM_MODEL');
    }
    // Check if specified parameters exist, remove them, and stop the process
    var interval = setInterval(function() {
        var urlParams = new URLSearchParams(window.location.search);
        var paramsExist = paramsToRemove.some(param => urlParams.has(param));
        if (paramsExist) {
            removeParams();
        } else {
            updateMenuLinks('');
            clearInterval(interval);
        }
    }, 100);
}
const cleanString = (str) => str.replace(/(-Platinum|-Gold|-Silver|-Bronze)/g, '');
// reload wishlist
const reloadSmartWishlist = () => {
    // let wishListInterval = setInterval(function() {
    //     const wishlistElms = document.querySelectorAll('.smartwishlist');
    //     const wishlistLoadedElms = document.querySelectorAll('.smartwishlist fa');
    //     if (wishlistElms.length > 0 && wishlistLoadedElms.length === 0) {
    //         clearInterval(wishListInterval);
    //         if (typeof ReloadSmartWishlist !== 'undefined') {
    //             ReloadSmartWishlist();
    //         }
    //         //remain code
    //     }
    // }, 1e3);
}
const setQuantitySelectorEvents = (qtySelector) => {
    if (qtySelector) {
        const decrementBtn = qtySelector.querySelector(".quantity-selector__button--decrement");
        const incrementBtn = qtySelector.querySelector(".quantity-selector__button--increment");
        const input = qtySelector.querySelector(".quantity-selector__current");
        // Decrement button event listener
        decrementBtn.addEventListener("click", (ev) => {
            ev.preventDefault();
            if (input.value > 1) {
                input.value = parseInt(input.value) - 1;
            }
            ev.stopPropagation(); // Stop the event from propagating
        });
        // Increment button event listener
        incrementBtn.addEventListener("click", (ev) => {
            ev.preventDefault();
            input.value = parseInt(input.value) + 1;
            ev.stopPropagation(); // Stop the event from propagating
        });
    }
}
const setSKUForProductItems = (products, registry) => {
    registry.useComponentPlugin("ProductItem", {
        name: "Component ProductItem",
        enabled: true,
        apply: () => ({
            async afterRender(element) {
                try {
                    let productItemElm = element.getRootElm();
                    if (productItemElm) {
                        let productId = productItemElm.dataset.productId;
                        let product = products.find(_product => parseInt(_product.id) === parseInt(productId));
                        if (product && product.variants && product.variants.length) {
                            const productTitleElm = productItemElm.querySelector(`.boost-sd__product-title`);
                            const existingSkuElm = productItemElm.querySelector(`.boost-sd__product-sku`);
                            if (productTitleElm && !existingSkuElm) {
                                const skuElm = document.createElement("div");
                                const productSku = cleanString(product.variants[0].sku);
                                skuElm.setAttribute("class", "boost-sd__product-sku");
                                skuElm.innerHTML = `<h4 class="prod-vendor">${productSku}</h4>`;
                                productTitleElm.parentNode.insertBefore(skuElm, productTitleElm.nextSibling);
                                const allVariantsIDs = product.variants.map(variant => variant.id);
                                productItemElm.setAttribute("data-variant", allVariantsIDs.join(","));
                            }
                            // Add wishlist at specific position
                            const imageRowTopElm = productItemElm.querySelector('.boost-sd__product-image-row--top');
                            const wishlistElm = productItemElm.querySelector('.smartwishlist');
                            if (imageRowTopElm && !wishlistElm) {
                                const imageRowBottomElm = document.createElement("div");
                                imageRowBottomElm.setAttribute("class", "boost-sd__product-image-row boost-sd__product-image-row--bottom");
                                imageRowBottomElm.innerHTML = `
                  <div class="boost-sd__product-image-column boost-sd__product-image-column--in-bottom boost-sd__product-image-column--right">
                    
                  </div>
                `;
                                imageRowTopElm.parentNode.insertBefore(imageRowBottomElm, imageRowTopElm.nextSibling);
                            }
                        }
                    }
                } catch (e) {
                    console.warn(e);
                }
            },
        }),
    });
    registry.useComponentPlugin("ProductItemListViewLayout", {
        name: "Component ProductItemListViewLayout",
        enabled: true,
        apply: () => ({
            async afterRender(element) {
                try {
                    let productItemElm = element.getRootElm();
                    if (productItemElm) {
                        let productId = productItemElm.dataset.productId;
                        let product = products.find(_product => parseInt(_product.id) === parseInt(productId));
                        const showProductDescription = false;
                        if (product && product.variants && product.variants.length) {
                            const productTitleElm = productItemElm.querySelector(`.boost-sd__product-title`);
                            const existingSkuElm = productItemElm.querySelector(`.boost-sd__product-sku`);
                            const ctaButtonsElm = productItemElm.querySelector('.boost-sd__product-item-list-view-layout-cta-buttons');
                            if (productTitleElm && !existingSkuElm) {
                                if (ctaButtonsElm) {
                                    const skuElm = document.createElement("div");
                                    const productSku = cleanString(product.variants[0].sku);
                                    skuElm.setAttribute("class", "boost-sd__product-sku");
                                    skuElm.innerHTML = `<h4 style="margin-top:17px;" class="prod-vendor">${productSku}</h4>`;
                                    ctaButtonsElm.insertBefore(skuElm, ctaButtonsElm.firstChild);
                                }
                                let listViewPriceLayoutElm = productItemElm.querySelector('.boost-sd__product-item-list-view-layout-price');
                                let existingSkuElm = ctaButtonsElm.querySelector(`.boost-sd__product-sku`);
                                if (listViewPriceLayoutElm && existingSkuElm) {
                                    ctaButtonsElm.insertBefore(listViewPriceLayoutElm, existingSkuElm.nextSibling);
                                }
                                if (product.body_html && product.body_html !== "" && product.body_html !== null && showProductDescription) {
                                    const productDescElm = document.createElement("div");
                                    productDescElm.setAttribute("class", "desc");
                                    productDescElm.innerHTML = `<p>${product.body_html}</p>`;
                                    productTitleElm.parentNode.insertBefore(productDescElm, productTitleElm.nextSibling);
                                }
                                const allVariantsIDs = product.variants.map(variant => variant.id);
                                productItemElm.setAttribute("data-variant", allVariantsIDs.join(","));
                            }
                            // Add wishlist at specific position
                            const imgBottomContainer = productItemElm.querySelector('.boost-sd__product-image-wrapper');
                            const wishlistElm = productItemElm.querySelector('.smartwishlist');
                            if (!wishlistElm && imgBottomContainer) {
                                let imageRowBottomElm = productItemElm.querySelector('.boost-sd__product-image-row--bottom');
                                if (!imageRowBottomElm) {
                                    imageRowBottomElm = document.createElement("div");
                                    imageRowBottomElm.setAttribute("class", "boost-sd__product-image-row boost-sd__product-image-row--bottom");
                                    const imageColumnRightElm = document.createElement("div");
                                    imageColumnRightElm.setAttribute("class", "boost-sd__product-image-column boost-sd__product-image-column--in-bottom boost-sd__product-image-column--right");
                  //                   imageColumnRightElm.innerHTML = `
                  //     <span class="smartwishlist boost-sd__button boost-sd__button--square boost-sd__button--no-minwidth"
                  //       style="width: 40px; font-style: normal; font-size: 20px!important; font-family: 'DIN Next'; font-weight: 500; text-transform: none; border: none !important; background: transparent !important;"
                  //       data-product="${productId}" data-variant="${product.variants[0].id}">
                  //     </span>
                  // `;
                                    imageRowBottomElm.appendChild(imageColumnRightElm);
                                    imgBottomContainer.appendChild(imageRowBottomElm);
                                }
                            }
                        }
                    }
                } catch (e) {
                    console.warn(e);
                }
            },
        }),
    });
}
const getYMMSearchData = async () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const year = urlParams.get('year') || sessionStorage.getItem('YMM_YEAR');
        const make = urlParams.get('make') || sessionStorage.getItem('YMM_MAKE');
        const model = urlParams.get('model') || sessionStorage.getItem('YMM_MODEL');
        if (!year || !make || !model) return null;
        return `${removeSpaces(year)}_${removeSpaces(make)}_${removeSpaces(model)}` || null;
    } catch (error) {
        console.warn(error);
        return null;
    }
}
let _urlParams = new URLSearchParams(window.location.search);
updateMenuLinks(_urlParams.toString());
/*------------------ For API & Filters Manipulation ------------------*/
// For products in collection pages
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
    (registry) => {
        registry.useModulePlugin("FilterAPI", {
            name: "Collection pages FilterAPI",
            apply(builder) {
                builder.on("beforeMethodCall", "get", async (payload) => {
                  const redirectCollectionList = ["diy-street-rod", "tubing", "diy-plumbing-kits", "tools", "fittings-adapters", "stainless-braided-hoses", "diy-brake-components", "quarter-midget", "individual-fasteners", "paint", "plastic-car-covers"];
                  const collectionHandle = window.location.href.split('/collections/')[1].split('?')[0].replace(/\//g, '');
                  payload.args[0].h_options = payload.args[0].h_options || [];
                  const ymmSearchData = await getYMMSearchData();
                  if(ymmSearchData !== null && !redirectCollectionList.includes(collectionHandle)){
                    payload.args[0].tag = payload.args[0].tag || [];
                    payload.args[0].tag.push(...[ymmSearchData]);
                    payload.args[0].tag_mode = 2;
                  }
                });
                builder.on("methodPending", "get", (payload) => {
                    return payload;
                });
                builder.on("methodFulfilled", "get", (payload) => {
                    // payload.extraRes = 'Boost';
                    let productsCopy = [...payload.result.products];
                    currentProductData = productsCopy;
                    // setup SKU for product items
                    setSKUForProductItems(productsCopy, registry);
                    return payload;
                });
                builder.on("methodReject", "get", (payload) => {
                    return payload;
                });
            },
        });
    }
);
// For products in Search widget
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
    (registry) => {
        registry.useModulePlugin("SearchAPI", {
            name: "Search widget SearchAPI",
            apply(builder) {
                builder.on("beforeMethodCall", "get", async (payload) => {
                  if (!payload.args[2]) {
                      payload.args[2] = [];
                  }
                  payload.args[2].h_options = payload.args[2].h_options || [];
                  const ymmSearchData = await getYMMSearchData();
                  if(ymmSearchData !== null){
                    payload.args[2].tag = payload.args[2].tag || [];
                    payload.args[2].tag.push(...[ymmSearchData]);
                    payload.args[0].tag_mode = 2;
                  }
                });
                builder.on("methodFulfilled", "get", (payload) => {
                    let productsCopy = [...payload.result.products];
                    currentProductData = productsCopy;
                    // setup SKU for product items
                    setSKUForProductItems(productsCopy, registry);
                    return payload;
                });
            },
        });
    }
);
// For products in Search result pages
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
    (registry) => {
        registry.useModulePlugin("SearchAPI", {
            name: "Search in collection SearchAPI",
            apply(builder) {
                builder.on("beforeMethodCall", "searchInCollection", async (payload) => {
                  payload.args[0].h_options = payload.args[0].h_options || [];
                  const ymmSearchData = await getYMMSearchData();
                  if(ymmSearchData !== null){
                    payload.args[0].tag = payload.args[0].tag || [];
                    payload.args[0].tag.push(...[ymmSearchData]);
                    payload.args[0].tag_mode = 2;
                  }
                });
                builder.on("methodFulfilled", "searchInCollection", (payload) => {
                    if (payload?.result?.products) {
                        let productsCopy = [...payload.result.products];
                        currentProductData = productsCopy;
                        // setup SKU for product items
                        setSKUForProductItems(productsCopy, registry);
                        // Customize search not redirect to search 
                        const requestId = payload?.result?.meta?.rid;
                        buildInfoWithRequestId(requestId, {
                            query_string: '',
                            action: 'filter'
                        });
                        buildRequestIdForProducts(requestId, payload?.result?.products, 'filter', true);
                    }
                    return payload;
                });
            },
        });
    }
);
// For recommendation API
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
    (registry) => {
        registry.useModulePlugin("RecommendationAPI", {
            name: "Recommendation widget API (hiding products based on tags)",
            apply(builder) {
                builder.on("beforeMethodCall", "get", async (payload) => {
                  payload.args[0].h_options = payload.args[0].h_options || [];
                     const ymmSearchData = await getYMMSearchData();
                     if(ymmSearchData !== null){
                        payload.args[0].tag = payload.args[0].tag || [];
                        payload.args[0].tag.push(...[ymmSearchData]);
                        payload.args[0].tag_mode = 2;

                       //binding tags for recommendation
                       payload.args[1].tags = payload.args[0].tag?.[0];
                     }
                });
                builder.on("methodFulfilled", "get", (payload) => {
                    if (payload?.result?.products) {
                        let productsCopy = [...payload.result.products];
                        // setup SKU for product items
                        setSKUForProductItems(productsCopy, registry);

                        // set fullwidth css if recomendation has only one item
                        if(payload.result.products.length === 1) {
                          const id = payload.args[0].wid;
                          const styleEl = document.createElement('style');
                          const styles = `
                            #boost-sd-widget-${id} .slick-track, #boost-sd-widget-${id} .slick-slide {width: 100% !important;}
                            #boost-sd-widget-${id} .slick-slide.slick-active.slick-cloned {display: none;}
                          `;
                          styleEl.innerHTML = styles;
                          document.head.appendChild(styleEl);
                        }
                    }
                    return payload;
                });
            },
        });
    }
);
/*------------------ For DOM Manipulation ------------------*/
// reload wishlist on view base
let haveWeMet = false
let haveWeMetGrid = false
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin("ViewAs", {
            name: "Component ViewAs",
            enabled: true,
            apply: () => ({
                beforeRender(element) {
                    try {
                        let ViewAsElm = element.getRootElm();
                        if (ViewAsElm) {
                            const collectionHandle = window.location.href.split('/collections/')[1].split('?')[0].replace(/\//g, '');
                            if (collectionHandle === "quick-order") {
                                if (!haveWeMet) {
                                    if (ViewAsElm.querySelector(".boost-sd__view-as-icon--list")) {
                                        ViewAsElm.querySelector(".boost-sd__view-as-icon--list").click();
                                    }
                                    if (ViewAsElm.querySelector(".boost-sd__view-as-icon--list.boost-sd__view-as-icon--active")) {
                                        haveWeMet = true
                                    }
                                }
                            } else {
                                if (!haveWeMetGrid) {
                                    if (ViewAsElm.querySelector(".boost-sd__view-as-icon--grid")) {
                                        ViewAsElm.querySelector(".boost-sd__view-as-icon--grid").click();
                                    }
                                    if (ViewAsElm.querySelector(".boost-sd__view-as-icon--grid.boost-sd__view-as-icon--active")) {
                                        haveWeMetGrid = true;
                                    }
                                }
                            }
                            if (ViewAsElm.querySelector(".boost-sd__view-as-icon--list")) {
                                ViewAsElm.querySelector(".boost-sd__view-as-icon--list").addEventListener("click", () => {
                                    reloadSmartWishlist();
                                });
                            }
                            if (ViewAsElm.querySelector(".boost-sd__view-as-icon--grid")) {
                                ViewAsElm.querySelector(".boost-sd__view-as-icon--grid").addEventListener("click", () => {
                                    reloadSmartWishlist();
                                });
                            }
                        }
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
    },
]);
// Set placeholder for collection search input
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin("ProductList", {
            name: "Component ProductList",
            enabled: true,
            apply: () => ({
                async afterRender(element) {
                    try {
                        const url = window.location.pathname.replace(/\/$/, '');
                        const collectionHandle = url.split('/').pop();
                        let collectionDetails = null;
                        if (collectionHandle !== "" && collectionHandle !== "all") {
                            collectionDetails = await fetch(`/collections/${collectionHandle}.json`).then((response) => response.json()).then((data) => data.collection).catch((error) => null);
                        }
                        let inputElm = document.querySelector('.boost-sd__in-collection-search-input');
                        if (inputElm) {
                            inputElm.setAttribute("placeholder", `Searching in ${collectionHandle === "all" ? "All Products" : collectionDetails?.title}`);
                        }
                        currentCollectionTitle = collectionHandle === "all" ? "All" : collectionDetails?.title;
                        let clearSearchElm = document.querySelector('button.boost-sd__button-text-x--clear-input-collection-search');
                        if (clearSearchElm) {
                            clearSearchElm.addEventListener("click", () => {
                                // if (FindYourVehicleAPI?.resetDropDowns) {
                                //     sessionStorage.removeItem('FYV');
                                //     sessionStorage.removeItem('YMM_YEAR');
                                //     sessionStorage.removeItem('YMM_MAKE');
                                //     sessionStorage.removeItem('YMM_MODEL');
                                //     removeParamsFromURL(["year", "make", "model"]);
                                //     FindYourVehicleAPI.resetDropDowns(0, false);
                                //     FindYourVehicleAPI.resetDropDowns(1);
                                //     FindYourVehicleAPI.resetDropDowns(2);
                                // }
                            });
                        }
                        let inCollectionSearchInputElm = document.querySelector('.boost-sd__in-collection-search-input');
                        if (inCollectionSearchInputElm) {
                            inCollectionSearchInputElm.addEventListener("keyup", () => {
                                clearTimeout(typingTimer);
                                typingTimer = setTimeout(() => {
                                    //removeParamsFromURL(["year", "make", "model"]);
                                }, doneTypingInterval);
                            });
                        }
                        let inCollectionSearchButtonGroupElm = document.querySelector('.boost-sd__in-collection-search-btn-group');
                        let hasDomBackToAllProductsElm = document.querySelector('.boost-sd__button-back-all--input-collection-search');
                        if (collectionHandle !== "all" && inCollectionSearchButtonGroupElm && !hasDomBackToAllProductsElm) {
                            let backToAllProductsElm = document.createElement("button");
                            backToAllProductsElm.setAttribute("class", "boost-sd__button boost-sd__button-back-all--input-collection-search");
                            backToAllProductsElm.setAttribute("type", "button");
                            backToAllProductsElm.setAttribute("aria-label", "Search all products");
                            backToAllProductsElm.setAttribute("title", "Search all products");
                            backToAllProductsElm.innerHTML = `
              <span class="boost-sd__button-icon">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 9H9V7a1 1 0 0 0-.62-.92 1 1 0 0 0-1.09.21l-3 3a1 1 0 0 0 0 1.42l3 3A1 1 0 0 0 8 14a.84.84 0 0 0 .38-.08A1 1 0 0 0 9 13v-2h3a6 6 0 0 1 6 6 1 1 0 0 0 2 0 8 8 0 0 0-8-8Z" fill="#31373d" class="fill-464646">
                  </path>
                </svg>
              </span>`;
                            backToAllProductsElm.addEventListener("click", () => {
                                triggerRefineByClearAll();
                                let urlParams = new URLSearchParams(window.location.search);
                                let paramsString = urlParams.toString();
                                const year = urlParams.get('year') || sessionStorage.getItem('YMM_YEAR');
                                const make = urlParams.get('make') || sessionStorage.getItem('YMM_MAKE');
                                const model = urlParams.get('model') || sessionStorage.getItem('YMM_MODEL');
                                if (year && make && model) {
                                    window.location.href = paramsString !== "" ? `/collections/all?${urlParams.toString()}&year=${year}&make=${make}&model=${model}` : "/collections/all";
                                } else {
                                    window.location.href = paramsString !== "" ? `/collections/all?${urlParams.toString()}` : "/collections/all";
                                }
                            });
                            inCollectionSearchButtonGroupElm.insertBefore(backToAllProductsElm, inCollectionSearchButtonGroupElm.firstChild);
                        } else if (collectionHandle === "all" && hasDomBackToAllProductsElm) {
                            hasDomBackToAllProductsElm.remove();
                        }
                        let boosterSdLayoutElm = document.querySelector('.boost-sd-layout');
                        let productListContainerElm = document.querySelector('.boost-sd-layout .boost-sd-right');
                        let filterBreadcrumbElm = document.getElementById('filter-breadcrumbs');
                        if (productListContainerElm) {
                            if (!filterBreadcrumbElm) {
                                filterBreadcrumbElm = document.createElement('div');
                                filterBreadcrumbElm.setAttribute('class', 'filter-breadcrumbs hidden');
                                filterBreadcrumbElm.setAttribute('id', 'filter-breadcrumbs');
                            }
                            filterBreadcrumbElm.innerHTML = "";
                            const year = sessionStorage.getItem('YMM_YEAR');
                            const make = removeSpaces(sessionStorage.getItem('YMM_MAKE'));
                            const model = removeSpaces(sessionStorage.getItem('YMM_MODEL'));
                            if (year && make && model) {
                                let yearMakeModelElm = document.createElement('span');
                                yearMakeModelElm.setAttribute('class', 'label-default year-make-model hidden');
                                let yearMakeModelString = (`${year} ${make} ${model}`);
                                yearMakeModelElm.innerHTML = `${yearMakeModelString} <i id="remove-ymm" class="fa fa-remove" aria-hidden="true"></i>`;
                                yearMakeModelElm.querySelector('#remove-ymm').addEventListener('click', () => {
                                    updateMenuLinks('');
                                    sessionStorage.removeItem('FYV');
                                    sessionStorage.removeItem('YMM_YEAR');
                                    sessionStorage.removeItem('YMM_MAKE');
                                    sessionStorage.removeItem('YMM_MODEL');
                                    // if (clearSearchElm) {
                                    //     clearSearchElm.click();
                                    // }
                                });
                                filterBreadcrumbElm.appendChild(yearMakeModelElm);
                            }
                            if (currentCollectionTitle !== "All") {
                                let collectionTitleElm = document.createElement('span');
                                collectionTitleElm.setAttribute('class', 'label-default category-title');
                                collectionTitleElm.innerHTML = `${currentCollectionTitle} <i id="remove-collection" class="fa fa-remove" aria-hidden="true"></i>`;
                                collectionTitleElm.querySelector('#remove-collection').addEventListener('click', () => {
                                    triggerRefineByClearAll();
                                    let urlParams = new URLSearchParams(window.location.search);
                                    let paramsString = urlParams.toString();
                                    const year = urlParams.get('year') || sessionStorage.getItem('YMM_YEAR');
                                    const make = urlParams.get('make') || sessionStorage.getItem('YMM_MAKE');
                                    const model = urlParams.get('model') || sessionStorage.getItem('YMM_MODEL');
                                    if (year && make && model) {
                                        window.location.href = paramsString !== "" ? `/collections/all?${urlParams.toString()}&year=${year}&make=${make}&model=${model}` : "/collections/all";
                                    } else {
                                        window.location.href = paramsString !== "" ? `/collections/all?${urlParams.toString()}` : "/collections/all";
                                    }
                                });
                                filterBreadcrumbElm.appendChild(collectionTitleElm);
                            }
                            if (boosterSdLayoutElm) {
                                if (filterBreadcrumbElm.textContent.trim() !== "") {
                                    boosterSdLayoutElm.classList.add('apply-filter-breadcrumb');
                                } else {
                                    boosterSdLayoutElm.classList.remove('apply-filter-breadcrumb');
                                }
                            }
                            productListContainerElm.prepend(filterBreadcrumbElm);
                        }
                        reloadSmartWishlist();
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
    },
]);
// add custom quantity input for product grid
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin("CTAButton", {
            name: "CTAButton - Custom add quantity input for product list",
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        let CTAButtonElm = element.getRootElm();
                        let CTAButtonElmParent = componentRegistry.getParentElmByPath(element, "ProductLink");
                        let ProductItemElm = CTAButtonElmParent.getParentElm();
                        if (CTAButtonElm && CTAButtonElmParent && ProductItemElm) {
                            let productLinkSelector = CTAButtonElmParent.getRootElm();
                            let ProductItemSelector = ProductItemElm.getRootElm();
                            if (CTAButtonElm?.disabled) {
                                const clonedCTAButton = CTAButtonElm.cloneNode(true);
                                CTAButtonElm.classList.add("hidden");
                                clonedCTAButton.classList.add("notify-customer--backstock", "SI_trigger");
                                let productData = currentProductData.find(product => parseInt(product.id) === parseInt(ProductItemSelector?.dataset?.productId));
                                clonedCTAButton.setAttribute("data-product-data", JSON.stringify(productData));
                                clonedCTAButton.querySelector('span.boost-sd__button-text').textContent = 'NOTIFY ME';
                                clonedCTAButton.disabled = false;
                                CTAButtonElm.parentNode.insertBefore(clonedCTAButton, CTAButtonElm.nextSibling);
                            } else {
                                CTAButtonElm.classList.remove("hidden");
                            }
                            if (productLinkSelector && ProductItemSelector) {
                                let qtyInputSelector = productLinkSelector.querySelector(".quantity-selector__wrapper");
                                let currentHref = productLinkSelector.getAttribute("href");
                                if (currentHref !== "javascript:void(0)") {
                                    productLinkSelector.setAttribute("data-href", productLinkSelector.getAttribute("href"));
                                    productLinkSelector.setAttribute("href", "javascript:void(0)");
                                    productLinkSelector.addEventListener("click", (e) => {
                                        e.preventDefault();
                                        if (e.target.tagName === "INPUT" || e.target.tagName === "BUTTON") return;
                                        window.location.href = productLinkSelector.getAttribute("data-href");
                                    });
                                }
                                if (!qtyInputSelector) {
                                    // prepend quantity input before CTAButtonElm
                                    let qtyInputContainer = document.createElement("div");
                                    qtyInputContainer.setAttribute("class", `quantity-selector__wrapper ${CTAButtonElm?.disabled ? "out-of-stock" : ""}`);
                                    qtyInputContainer.innerHTML = `
                    <button type="button" class="quantity-selector__button quantity-selector__button--decrement" aria-label="quantity decrease">
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20">
                        <path d="M0 9h20v2H0z"></path>
                      </svg>
                    </button>
                    <input id="quantity-${ProductItemSelector?.dataset?.productId}" type="number" class="quantity-selector__current" value="1" min="1" aria-label="quantity">
                    <button type="button" class="quantity-selector__button quantity-selector__button--increment" aria-label="quantity increase">
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20">
                        <path d="M0 9h20v2H0z"></path>
                        <path d="M9 0h2v20H9z"></path>
                      </svg>
                    </button>
                  `;
                                    CTAButtonElm.parentNode.insertBefore(qtyInputContainer, CTAButtonElm);
                                    setQuantitySelectorEvents(qtyInputContainer);
                                }
                            }
                        }
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
    },
]);
// add custom quantity input for product list view
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin("ProductItemListViewLayout", {
            name: "ProductItemListViewLayout - Custom add quantity input for product list",
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        let ProductItemElm = element.getRootElm();
                        let CTAButtonElm = ProductItemElm.querySelector(".boost-sd__product-item-list-view-layout-cta-buttons .boost-sd__btn-add-to-cart") || ProductItemElm.querySelector(".boost-sd__product-item-list-view-layout-cta-buttons [disabled][title=\"Out of Stock\"]");
                        if (CTAButtonElm && ProductItemElm) {
                            if (CTAButtonElm?.disabled) {
                                const clonedCTAButton = CTAButtonElm.cloneNode(true);
                                CTAButtonElm.classList.add("hidden");
                                clonedCTAButton.classList.add("notify-customer--backstock", "SI_trigger");
                                let productData = currentProductData.find(product => parseInt(product.id) === parseInt(ProductItemElm?.dataset?.productId));
                                clonedCTAButton.setAttribute("data-product-data", JSON.stringify(productData));
                                clonedCTAButton.querySelector('span.boost-sd__button-text').textContent = 'NOTIFY ME';
                                clonedCTAButton.disabled = false;
                                CTAButtonElm.parentNode.insertBefore(clonedCTAButton, CTAButtonElm.nextSibling);
                            } else {
                                CTAButtonElm.classList.remove("hidden");
                            }
                            let qtyInputSelector = ProductItemElm.querySelector(".quantity-selector__wrapper");
                            if (!qtyInputSelector) {
                                // prepend quantity input before CTAButtonElm
                                let qtyInputContainer = document.createElement("div");
                                qtyInputContainer.setAttribute("class", `quantity-selector__wrapper ${CTAButtonElm?.disabled ? "out-of-stock" : ""}`);
                                qtyInputContainer.innerHTML = `
                    <button type="button" class="quantity-selector__button quantity-selector__button--decrement" aria-label="quantity decrease">
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20">
                        <path d="M0 9h20v2H0z"></path>
                      </svg>
                    </button>
                    <input id="quantity-${ProductItemElm?.dataset?.productId}" type="number" class="quantity-selector__current" value="1" min="1" aria-label="quantity">
                    <button type="button" class="quantity-selector__button quantity-selector__button--increment" aria-label="quantity increase">
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20">
                        <path d="M0 9h20v2H0z"></path>
                        <path d="M9 0h2v20H9z"></path>
                      </svg>
                    </button>
                  `;
                                CTAButtonElm.parentNode.insertBefore(qtyInputContainer, CTAButtonElm);
                                setQuantitySelectorEvents(qtyInputContainer);
                            }
                        }
                        let boosterSdLayoutElm = document.querySelector('.boost-sd-layout');
                        let productListContainerElm = document.querySelector('.boost-sd-layout .boost-sd-right');
                        let filterBreadcrumbElm = document.getElementById('filter-breadcrumbs');
                        if (productListContainerElm) {
                            if (!filterBreadcrumbElm) {
                                filterBreadcrumbElm = document.createElement('div');
                                filterBreadcrumbElm.setAttribute('class', 'filter-breadcrumbs hidden');
                                filterBreadcrumbElm.setAttribute('id', 'filter-breadcrumbs');
                            }
                            filterBreadcrumbElm.innerHTML = "";
                            const year = sessionStorage.getItem('YMM_YEAR');
                            const make = removeSpaces(sessionStorage.getItem('YMM_MAKE'));
                            const model = removeSpaces(sessionStorage.getItem('YMM_MODEL'));
                            if (year && make && model) {
                                let yearMakeModelElm = document.createElement('span');
                                yearMakeModelElm.setAttribute('class', 'label-default year-make-model hidden');
                                let yearMakeModelString = (`${year} ${make} ${model}`);
                                yearMakeModelElm.innerHTML = `${yearMakeModelString} <i id="remove-ymm" class="fa fa-remove" aria-hidden="true"></i>`;
                                yearMakeModelElm.querySelector('#remove-ymm').addEventListener('click', () => {
                                    updateMenuLinks('');
                                    sessionStorage.removeItem('FYV');
                                    sessionStorage.removeItem('YMM_YEAR');
                                    sessionStorage.removeItem('YMM_MAKE');
                                    sessionStorage.removeItem('YMM_MODEL');
                                    // if (clearSearchElm) {
                                    //     clearSearchElm.click();
                                    // }
                                });
                                filterBreadcrumbElm.appendChild(yearMakeModelElm);
                            }
                            if (currentCollectionTitle !== "All") {
                                let collectionTitleElm = document.createElement('span');
                                collectionTitleElm.setAttribute('class', 'label-default category-title');
                                collectionTitleElm.innerHTML = `${currentCollectionTitle} <i id="remove-collection" class="fa fa-remove" aria-hidden="true"></i>`;
                                collectionTitleElm.querySelector('#remove-collection').addEventListener('click', () => {
                                    let urlParams = new URLSearchParams(window.location.search);
                                    let paramsString = urlParams.toString();
                                    const year = urlParams.get('year') || sessionStorage.getItem('YMM_YEAR');
                                    const make = urlParams.get('make') || sessionStorage.getItem('YMM_MAKE');
                                    const model = urlParams.get('model') || sessionStorage.getItem('YMM_MODEL');
                                    if (year && make && model) {
                                        window.location.href = paramsString !== "" ? `/collections/all?${urlParams.toString()}&year=${year}&make=${make}&model=${model}` : "/collections/all";
                                    } else {
                                        window.location.href = paramsString !== "" ? `/collections/all?${urlParams.toString()}` : "/collections/all";
                                    }
                                });
                                filterBreadcrumbElm.appendChild(collectionTitleElm);
                            }
                            if (boosterSdLayoutElm) {
                                if (filterBreadcrumbElm.textContent.trim() !== "") {
                                    boosterSdLayoutElm.classList.add('apply-filter-breadcrumb');
                                } else {
                                    boosterSdLayoutElm.classList.remove('apply-filter-breadcrumb');
                                }
                            }
                            productListContainerElm.prepend(filterBreadcrumbElm);
                        }
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
    },
]);
// open filter tree by default
let filterToggled = false
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FilterTree', {
            name: 'FilterTreeStateProvider - Custom open default filterTree',
            apply: () => ({
                afterRender(element) {
                    try {
                        let toggleButton = document.querySelector('.boost-sd__filter-tree-toggle-button')
                        if (toggleButton && !filterToggled) {
                            toggleButton.click()
                            filterToggled = true
                        }
                    } catch (error) {
                        console.warn(error)
                    }
                },
            }),
        });
    }
]);
// update cart item count before adding to the cart
let isAddToCart = false;
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useModulePlugin('CartAPI', {
            name: 'update cart item count',
            apply(builder) {
                builder.on('beforeMethodCall', 'addToCart', async (payload) => {
                    const variantId = payload.args[0];
                    const variantElm = document.querySelector(`[data-variant="${variantId}"]`);
                    if (variantElm) {
                        const qtyInput = variantElm.querySelector('.quantity-selector__current');
                        payload.args[1] = qtyInput ? parseInt(qtyInput.value, 10) : payload.args[1];
                    }
                    isAddToCart = true;
                    return payload;
                });
                builder.on('methodFulfilled', 'addToCart', async (payload) => {
                  if(theme.template === "cart"){
                      location.reload();
                  }
                  return payload;
                });
                builder.on('methodFulfilled', 'getCartItems', async (payload) => {
                    const cartCountElms = Array.from(document.querySelectorAll('.cart-count')) || [];
                    const {
                        result: {
                            item_count = null
                        }
                    } = payload;
                    if (cartCountElms.length > 0) {
                        for (let index = 0; index < cartCountElms.length; index++) {
                            const cartCountElm = cartCountElms[index];
                            if (item_count !== null) {
                                const cartCounterElm = cartCountElm.querySelector('#head-cart-counter');
                                if (cartCounterElm) cartCounterElm.textContent = item_count;
                                if (item_count > 0) {
                                    cartCountElm.removeAttribute('style');
                                } else {
                                    cartCountElm.setAttribute('style', 'display: none;');
                                }
                            }
                        }
                    }
                  
                    if(isAddToCart && typeof thisGetUpdatedCart === "function"){
                      thisGetUpdatedCart(payload?.result);
                    }
                    return payload;
                });
            }
        });
    }
]);
//  Recommendation widget - render wishlist button
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('RecommendationWidget.Slider', {
            name: 'RecommendationWidgetSlider - Custom open default filterTree',
            apply: () => ({
                props(props, element) {
                    // Start boost 229308
                    const slidesToScroll = props?.responsive[0]?.settings?.slidesToScroll;
                    const slidesToShow = props?.responsive[0]?.settings?.slidesToShow;
                    if (slidesToScroll != null && slidesToShow != null && window.innerWidth < 768) {
                        props.responsive[0].settings.slidesToScroll = 1;
                        props.responsive[0].settings.slidesToShow = 1;
                    }
                    // End boost 229308

                    // Slider in Ajax Cart
                    let ajaxWidgetId = element.getParentElm().getParams().props.params.wid;
                    if(ajaxWidgetId == "collectionpage-385207"){
                        props.slidesToShow = 2;
                        props.responsive[1].settings.slidesToScroll = 1;
                        props.responsive[1].settings.slidesToShow = 1;
                    }
                    // End Slider in Ajax Cart
                  
                    return props;
                },
                afterRender(element) {
                    try {
                        reloadSmartWishlist();
                    } catch (error) {
                        console.warn(error)
                    }
                },
            }),
        });
    }
]);

if (boostSDAppConfig?.filterSettings) {
    boostSDAppConfig.filterSettings.filterAvoidStickyHeader = ['.main-logo-search-header .sticky-visible']; //Please modify this array
}
// ==========move in-collection search bar inside toolbar.
let boostWindowWidth = 0; // Initialize the windowWidth variable to store the width.
const isMobile = () => {
    if (!boostWindowWidth) {
        // We don't want to re-calculate the width every time because it causes a style recalculation every time.
        // So we store it
        boostWindowWidth = window.innerWidth;
        // Calculate the width on resize
        window.addEventListener('resize', () => {
            boostWindowWidth = window.innerWidth;
        });
    }
    return boostWindowWidth <= 768;
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin("ProductList", {
            name: "Component ProductList",
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        let inputElm = document.querySelector('.boost-sd__in-collection-search');
                        let ViewAsElm = document.querySelector('.boost-sd__toolbar--2_1 > .boost-sd__toolbar-item--view-as');
                        let incollectinSearchInToolbar = document.querySelector('.boost-sd__toolbar--2_1 .boost-sd__in-collection-search-input')
                        let mobileToolbarElm = document.querySelector('.boost-sd__toolbar-top-mobile');
                        if (inputElm && ViewAsElm && !isMobile() && element.getRenderCount() == 1) {
                            ViewAsElm.after(inputElm);
                            inputElm.style.margin = 0;
                            if (incollectinSearchInToolbar) {
                                incollectinSearchInToolbar.focus()
                            }
                        }
                        if (inputElm && mobileToolbarElm && isMobile() && element.getRenderCount() == 1) {
                            mobileToolbarElm.prepend(inputElm);
                            inputElm.style.margin = 0;
                            inputElm.style.padding = "10px 0px";
                            mobileToolbarElm.classList.add("custom")
                            if (incollectinSearchInToolbar) {
                                incollectinSearchInToolbar.focus()
                            }
                        }
                        let searchResultInputForm = document.querySelector(".boost-sd-container-search-page .boost-sd__search-form")
                        if (searchResultInputForm && ViewAsElm && !isMobile() && element.getRenderCount() == 1) {
                            ViewAsElm.after(searchResultInputForm);
                        }
                        if (searchResultInputForm && mobileToolbarElm && isMobile() && element.getRenderCount() == 1) {
                            mobileToolbarElm.prepend(searchResultInputForm);
                            mobileToolbarElm.classList.add("custom")
                            searchResultInputForm.style.margin = "10px 0px";
                        }
                       const collectionSearchEmptyResultSelector = document.querySelector(".boost-sd__product-list-pagination-in-collection-search-empty-message");
                       const emptyResult = document.querySelector('[data-empty-result]');
                       if(collectionSearchEmptyResultSelector && !emptyResult){
                         let emptyText = replaceLinkShortcode(collectionSearchEmptyResultSelector.textContent, "/pages/new-product-request-form");
                             emptyText = replaceContactLinkShortcode(emptyText, "/pages/contact");
                             emptyText = replaceClearAllLinkShortcode(emptyText, "clearAllLink();");
                             emptyText = replaceNewLineShortcode(emptyText, "<br/>");
                         
                         collectionSearchEmptyResultSelector.innerHTML = `<p data-empty-result><em>${emptyText}</em></p>`;
                       }else if(emptyResult && !collectionSearchEmptyResultSelector){
                         emptyResult.remove();
                       }
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
    },
]);
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        const changeProductImageResolution = {
            name: "Change Product Image resolution",
            apply() {
                return {
                    props(props) {
                        props.deviceSizes = [200, 300, 400];
                        props.imageSizes = [400, 600, 800];
                        return props;
                    },
                };
            },
        };
        componentRegistry.useComponentPlugin(
            "ProductImage",
            changeProductImageResolution
        );
    },
]);
clearAllActiveSearches();

// ticket #236547
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin("Slider", {
            name: "Component Slider",
            enabled: true,
            apply() {
                return {
                    props(props) {
                        try {
                          console.log(props.responsive)
                          props.responsive = [
                              {
                                  "breakpoint": 992,
                                  "settings": {
                                      "slidesToShow": 3,
                                      "slidesToScroll": 3
                                  }
                              },
                              {
                                  "breakpoint": 767,
                                  "settings": {
                                      "slidesToShow": 2,
                                      "slidesToScroll": 2
                                  }
                              },
                              {
                                  "breakpoint": 425,
                                  "settings": {
                                      "slidesToShow": 1,
                                      "slidesToScroll": 1
                                  }
                              }
                            
                          ]
                          return props;
                        } catch (e) {
                            console.warn("Component Slider" , e);
                        }
                    },
                };
            }
        });
    },
]);

/**** boost fix issue collection all wrong collection_scope ***/
const originalFetch = window.fetch;

const updateQueryParam = (url, param, value)=> {
  // Parse the URL
  let urlObj = new URL(url);

  // Get the search parameters
  let params = new URLSearchParams(urlObj.search);

  // Set the new parameter value
  params.set(param, value);

  // Update the search part of the URL
  urlObj.search = params.toString();

  // Return the updated URL
  return urlObj.toString();
}

window.fetch = (url, options)=>{
  const valid = 'https://services.mybcapps.com/bc-sf-filter/filter';
  const validSearch = 'https://services.mybcapps.com/bc-sf-filter/search/';
  
  /**
   * The CORE logic defined here, we can check to get a specific URL that we want to update
   * options.method to get the API Method // GET | POST | PUT | PATCH | DELETE
   * Rule of thumb
   * - GET: alter the URL query params
   * - Other methods: alter the body payload, via `options.body`
   */
  
  if(url.indexOf(valid) !== -1 && window.location.pathname === '/collections/all'){
    const updatedUrl = updateQueryParam(url, 'collection_scope', 0);
    url = updatedUrl;
  }

  if(url.indexOf('pf_c_collection=0&')){
    url = url.replace('pf_c_collection=0&', '');
  }

  return originalFetch(url, options);
};
/**** End boost fix issue collection all wrong collection_scope ***/

/**** boost customize refined by -- START ***/
function extractValues(url) {
  const urlObj = new URL(url);

  // Check url containing '/collections/'
  const pathSegments = urlObj.pathname.split('/');
  if (pathSegments.length < 3 || pathSegments[1] !== 'collections') {
    return null; // Return invalid
  }

  const collectionName = pathSegments[2]; // Extract collection

  // Extract params 'q'
  const queryParam = urlObj.searchParams.get('q');

  // Return value if both collectionName and queryParam are valid 
  if (collectionName && queryParam) {
    return { collectionName, queryParam };
  }
  
  return null; // Return invalid 
}

// Customize Hidden Category if is individual collections
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin("FilterOption", {
            name: "Component FilterOption",
            enabled: true,
            apply: () => ({
                props(props) {
                },
                afterRender(){
                  const {collectionName, queryParam} = extractValues(window.location.href) || {};
                  if(queryParam && collectionName) {
                      const firstCollection = document.querySelector(".boost-sd__filter-option");

                      if(!firstCollection) return;
                      if(collectionName === "all"){
                        firstCollection.style.display = "block";
                      } else {
                        const optionItemsCollections = firstCollection.querySelectorAll('.boost-sd__filter-option-listitem .boost-sd__filter-option-item')?.length;
                        if(optionItemsCollections > 2) {
                          firstCollection.style.display = "block";
                        } else {
                          firstCollection.style.display = "none";
                        }
                      }
                    }
                  /* Hide filter collection for other collections */
                  fnHideFilterCollection();
              }
            }),
        });
    },
]);
/**** boost customize refined by --- END ***/

// Ticket Customize Tracking event when search keep At Collection Page.
const SESSION_KEY = 'boostSDSessionId';
const REQUEST_ID_FILTER_KEY = 'boostSDRequestIdFilterKey';
const REQUEST_ID_SEARCH_KEY = 'boostSDRequestIdSearchKey';
const REQUEST_ID_SUGGEST_KEY = 'boostSDRequestIdSuggestKey';
const REQUEST_ID_SEARCH_TERM_SUGGEST_KEY = 'boostSDRequestIdSearchTermSuggestKey';
const REQUEST_ID_RECOMMENDATION_KEY = 'boostSDRequestIdRecommendationKey';
const REQUEST_ID_SAVE_INFO_REQUEST_KEY = 'boostSDRequestIdSaveInfoRequest';
const REQUEST_ID_MORE_INFORMATION_KEY = 'boostSDRequestIdMoreInformationKey';
const CLICK_SUGGESTION_KEY = 'boostSDOnClickSuggestion';

function getLocalStorage(key){
  try {
    const value = localStorage.getItem(key);
    if (!value) return null;
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}

function setLocalStorage(key, value){
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    localStorage.setItem(key, '');
  }
}

function getMaxValue(localStorageKey, maxRecord = 20){
  let preValue = getLocalStorage(localStorageKey) || {};
  // KEEP max quality of record save
  if (Object.keys(preValue).length >= maxRecord) {
    const preValueTemp = {};
    const keys = Object.keys(preValue);
    const values = Object.values(preValue);

    for (let i = 0; i < maxRecord; i++) {
      preValueTemp[keys[i]] = values[i];
    }

    preValue = preValueTemp;
  }

  return preValue;
}

function buildInfoWithRequestId(requestId, data){
  const copyQueryString = data.query_string;

  if (data.query_string) {
    const search = data.query_string;

    const hashes = search.slice(search.indexOf('?') + 1).split('&');
    data.query_string = '';

    hashes.forEach((hash, i) => {
      const [key, val] = hash.split('=');
      if (key === 'q') {
        if (!data.searchTerm) data.searchTerm = val;
        data.searchTerm = data.searchTerm?.replace('%', '');
        data.query_string += `${decodeURIComponent(key)}=${decodeURIComponent(data.searchTerm)}&`;
      }

      if (key === 'collection_scope' || key.startsWith('pf_')) {
        data.query_string += `${decodeURIComponent(key)}=${decodeURIComponent(val)}&`;
      }
    });

    if (data.query_string.length > 0) {
      // remove last is &
      data.query_string = data.query_string.substring(0, data.query_string.length - 1);
    }
  }

  // get origin query string if it not transfer data
  if (data.query_string === '') data.query_string = copyQueryString;

  const QUALITY_MAX_SAVE = 20;

  if (requestId && data) {
    const preValue = getMaxValue(REQUEST_ID_SAVE_INFO_REQUEST_KEY, QUALITY_MAX_SAVE) || {};

    setLocalStorage(REQUEST_ID_SAVE_INFO_REQUEST_KEY, {
      [requestId]: data,
      ...preValue,
    });
  }
}

// NOTE: Find place use buildRequestIdForProducts of Search API in collection search page above
function buildRequestIdForProducts(requestId,products,type,isKeepPreData){
  const QUALITY_MAX_SAVE = 10;
  let REQUEST_ID_STORAGE_KEY = '';

  switch (type) {
    case 'filter':
      REQUEST_ID_STORAGE_KEY = REQUEST_ID_FILTER_KEY;
      break;

    case 'search': 
      REQUEST_ID_STORAGE_KEY = REQUEST_ID_SEARCH_KEY;
      break;

    case 'suggest':
      REQUEST_ID_STORAGE_KEY = REQUEST_ID_SUGGEST_KEY;
      break;

    case 'recommendation':
      REQUEST_ID_STORAGE_KEY = REQUEST_ID_RECOMMENDATION_KEY;
      break;

    default:
      return;
  }
  
  if (requestId && Array.isArray(products) && products.length > 0) {
    const productIds = products.map((productItem) => Number(productItem.id || 0));

    let preValue = {};
    if (isKeepPreData) {
      preValue = getMaxValue(REQUEST_ID_STORAGE_KEY, QUALITY_MAX_SAVE) || {};
    }
    
    setLocalStorage(REQUEST_ID_STORAGE_KEY, {
      [requestId]: productIds,
      ...preValue,
    });
  }
}

// Hide collection filter option for collection pages (exc All)
function fnHideFilterCollection(){
  let filteredCollectionEl = document.querySelector('.boost-sd__filter-option-item-multilevel-collections .boost-sd__filter-option-item-button--selected');
  if(filteredCollectionEl){
    let filteredCollectionHref = filteredCollectionEl.href;
    if(!filteredCollectionHref.includes('/collections/all')){
      if(!document.querySelector('body.boost-sd__hide-cfo')){
        document.querySelector('body').classList.add('boost-sd__hide-cfo');
      }
    }else{
        document.querySelector('body').classList.remove('boost-sd__hide-cfo');
    }
  }
}

// Customize JS hidden Filter Option Collection When search in individual collection.
window.addEventListener('popstate', function(event) {
  console.log('URL đã thay đổi:', window.location.href);
});

// Customize when clicking
document.addEventListener("click", function(event) {
    if(event.target.className == 'boost-sd-right' || event.target.className == 'boost-sd__filter-tree-wrapper'){
      document.querySelector('.boost-sd__filter-tree-toggle-button').click();
    }
});